<script>
/**
 * Descripción: Componente Layout the la aplicación
 *
 * @displayName TheLayout
 */

import store from '@/store';

import BaseLocalHelper from '@/helpers/BaseLocalHelper';

import { mapActions } from 'vuex';

const TheToolbar = () => import('@/components/core/layouts/TheToolbar');

const TheMenu = () => import('@/components/core/drawers/TheMenu');

const TheFooter = () => import('@/components/core/layouts/TheFooter');

export default {
  name: 'TheLayout',

  components: {
    TheToolbar,
    TheMenu,
    TheFooter
  },

  data() {
    return {
      fab: false,
      lblSigout: BaseLocalHelper.$_LabelBtnSigout,
      showItems: true,
      /**
       * Tamaño de la pantalla del dispositivo
       */
      windowSize: {
        x: 0,
        y: 0
      }
    };
  },

  mounted() {
    /**
     * Determinar que tipo de pantalla
     */
    this.onResize();
  },

  methods: {
    ...mapActions('navbar', ['changeConfigStatus']),

    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },

    toTop() {
      this.$vuetify.goTo(0);
    },

    /**
     * Determinar que pantall
     */
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };

      this.windowSize.x > 551
        ? (this.showItems = true)
        : (this.showItems = false);
    },

    SignOut() {
      store.commit('authentication/LOGOUT', false, {
        root: true
      });
    }
  }
};
</script>

<template>
  <div id="app" v-resize="onResize">
    <TheMenu :show="showItems" />

    <TheToolbar>
      <div slot="buttons">
        <div v-if="showItems">
          <v-row>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="SignOut">
                    <v-icon>mdi-logout</v-icon>
                  </v-btn>
                </template>
                <span>{{ lblSigout }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
        <v-row v-else>
          <v-menu close-on-content-click>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-account-cog</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item>
                <v-btn @click="SignOut" text color="error">
                  {{ lblSigout }}
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </div>
    </TheToolbar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container class="scroll-y">
        <slot name="RenderBody"></slot>
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          right
          color="primary"
          @click="toTop"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-container>
    </v-main>
    <TheFooter />
  </div>
</template>
